import { render, staticRenderFns } from "./pro_02_folding_forming.vue?vue&type=template&id=3c84f2da&lang=pug&"
import script from "./pro_02_folding_forming.vue?vue&type=script&lang=js&"
export * from "./pro_02_folding_forming.vue?vue&type=script&lang=js&"
import style0 from "./pro_02_folding_forming.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports